import { render, staticRenderFns } from "./TeamActivityEmptyState.vue?vue&type=template&id=a47dd202"
import script from "./TeamActivityEmptyState.vue?vue&type=script&lang=js"
export * from "./TeamActivityEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports